import React from 'react';
import { StyledButton } from './styles';
import clsx from 'clsx';

type TProps = {
  title: string;
  width?: number;
  className?: string;
  disabled?: boolean;
  handleClick?: () => void;
}

export const Button: React.FC<TProps> = ({className, title, width, disabled, handleClick}) => {
  return (
    <StyledButton className={clsx(className, {disabled})} disabled={disabled} width={width} onClick={handleClick}>{title}</StyledButton>
  )
}
